export default {"src":"/_next/static/media/chiliz.963e930d.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};